import React from 'react'
import Button from './Button'

export default function EmptyState({ emoji, title, description, actionLabel, onAction }) {
  return (
    <div className="px-4 py-12 text-center max-w-md mx-auto">
      <div className="bg-white rounded-2xl p-8">
        <div className="text-6xl mb-4" aria-hidden="true">{emoji}</div>
        <h2 className="text-2xl font-bold text-gray-900 mb-3">{title}</h2>
        <p className="text-gray-600 mb-6">{description}</p>
        <Button
          onClick={onAction}
          variant="primary"
          theme="dark"
          size="lg"
          fullWidth
        >
          {actionLabel}
        </Button>
      </div>
    </div>
  )
}
